<template>
  <v-btn
    primary light
    :loading="loading"
    @click.native.stop="goToMessenger()">
   <slot></slot>
  </v-btn>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import user from '@/mixins/user'
  export default {
    mixins: [user],
    computed: mapGetters({
      loading: 'skiliko/conversations/isLoading'
    }),
    methods: {
      ...mapActions({
        findConversationWith: 'skiliko/conversations/findConversationWith'
      }),
      goToMessenger () {
        this.findConversationWith({ user: this.user.chatable_id })
          .then(conversation => {
            this.$router.push({ name: 'MessengerMessage', params: { id: conversation._id } })
          })
          .catch(_ => {
            this.$router.push({
              name: 'MessengerNew',
              query: {
                _id: this.user.chatable_id,
                name: this.user.nickname,
                scope: 'user',
                externalId: this.user.id
              }
            })
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/user/MessageButton.vue